import React from "react";

interface FacetItem {
  id: number;
  name: string;
}

interface Props {
  searchInput: string;
  onRemoveSearchInput: () => void;
  showOnlyFavorites: boolean;
  onRemoveFavorites: () => void;
  selectedEventTypes: FacetItem[];
  onRemoveEventType: (name: string) => void;
  selectedCategories: FacetItem[];
  onRemoveCategory: (name: string) => void;
  selectedTrades: FacetItem[];
  onRemoveTrade: (name: string) => void;
  selectedBusinessRoles: FacetItem[];
  onRemoveBusinessRole: (name: string) => void;
  onClearAll: () => void;
}

function Chip({ label, onRemove }: { label: string; onRemove: () => void }) {
  return (
    <span className="flex items-center gap-1 rounded-full bg-gray-200 px-3 py-1 text-gray-800 dark:bg-gray-700 dark:text-gray-100">
      {label}
      <button
        className="ml-1 text-gray-600 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white"
        onClick={onRemove}
        type="button"
      >
        ×
      </button>
    </span>
  );
}

export default function CurrentFilterChips({
  searchInput,
  onRemoveSearchInput,
  showOnlyFavorites,
  onRemoveFavorites,
  selectedEventTypes,
  onRemoveEventType,
  selectedCategories,
  onRemoveCategory,
  selectedTrades,
  onRemoveTrade,
  selectedBusinessRoles,
  onRemoveBusinessRole,
  onClearAll,
}: Props) {
  const hasAnyActiveFilter =
    !!searchInput ||
    showOnlyFavorites ||
    selectedEventTypes.length > 0 ||
    selectedCategories.length > 0 ||
    selectedTrades.length > 0 ||
    selectedBusinessRoles.length > 0;

  if (!hasAnyActiveFilter) {
    return null;
  }

  return (
    <div className="mb-6 flex flex-wrap items-center gap-2 text-sm">
      <span className="text-gray-700 dark:text-gray-300">Active filters:</span>

      {searchInput && (
        <Chip label={searchInput} onRemove={onRemoveSearchInput} />
      )}

      {showOnlyFavorites && (
        <Chip label="Favorites" onRemove={onRemoveFavorites} />
      )}

      {selectedEventTypes.map((t) => (
        <Chip
          key={t.name}
          label={t.name}
          onRemove={() => onRemoveEventType(t.name)}
        />
      ))}

      {selectedCategories.map((c) => (
        <Chip
          key={c.name}
          label={c.name}
          onRemove={() => onRemoveCategory(c.name)}
        />
      ))}

      {selectedTrades.map((t) => (
        <Chip
          key={t.name}
          label={t.name}
          onRemove={() => onRemoveTrade(t.name)}
        />
      ))}

      {selectedBusinessRoles.map((r) => (
        <Chip
          key={r.name}
          label={r.name}
          onRemove={() => onRemoveBusinessRole(r.name)}
        />
      ))}

      <button
        className="ml-2 text-blue-600 dark:text-blue-400 underline"
        onClick={onClearAll}
        type="button"
      >
        Clear all
      </button>
    </div>
  );
}
